import { render, staticRenderFns } from "./prevParticipations.vue?vue&type=template&id=665b90d8&scoped=true"
import script from "./prevParticipations.vue?vue&type=script&lang=js"
export * from "./prevParticipations.vue?vue&type=script&lang=js"
import style0 from "./prevParticipations.vue?vue&type=style&index=0&id=665b90d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "665b90d8",
  null
  
)

export default component.exports